import { IWebStorage } from '@wix/native-components-infra/dist/src/types/types';

export abstract class PlatformStorage {
  protected constructor(protected readonly storage: IWebStorage) {}

  clear(): void {
    this.storage.clear();
  }
}
